export const FUEL_TYPE = { key: 'fuel', value: '純油車' };
export const ELECTRIC_TYPE = { key: 'electric', value: '純電車' };
export const FUEL_ELECTRIC_TYPE = { key: 'fuel_electric', value: '油電混合車' };

export const ENERGY_SOURCE_TYPES = [FUEL_TYPE, ELECTRIC_TYPE, FUEL_ELECTRIC_TYPE];

export const ENERGY_SOURCE = {
  [FUEL_TYPE.key]: FUEL_TYPE,
  [ELECTRIC_TYPE.key]: ELECTRIC_TYPE,
  [FUEL_ELECTRIC_TYPE.key]: FUEL_ELECTRIC_TYPE,
}
